import { render, staticRenderFns } from "./ExpenseSubmitNew.vue?vue&type=template&id=4626b140&scoped=true"
import script from "./ExpenseSubmitNew.vue?vue&type=script&lang=js"
export * from "./ExpenseSubmitNew.vue?vue&type=script&lang=js"
import style0 from "./ExpenseSubmitNew.vue?vue&type=style&index=0&id=4626b140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626b140",
  null
  
)

export default component.exports